import React, { Component } from 'react'
import { Provider, observer } from 'mobx-react'
import { Route, Switch, Redirect, withRouter } from 'react-router-dom'
import Helmet from 'react-helmet'
// import _get from 'lodash/get'
import { CookiesProvider } from 'react-cookie'
import { Layout, message } from 'antd'

import ConnectedLocaleProvider from './providers/locale'
import ConnectedIntlProvider from './providers/intl'
// import Error404 from './Error404'
import Header from '../common/Header'
import Footer from '../common/Footer'
import AuthModal from '../common/AuthModal'

// import HomePage from './HomePage'
import EventListPage from './EventListPage'
import EventPage from './EventPage'
// import EventRegisterPage from './EventRegisterPage'
// import EventRegisterPage from './pages/EventRegister'
import EventRegistration from './pages/EventRegistration'
// import RegistrationPage from './RegistrationPage'
// import RegistrationConfirmPage from './RegistrationConfirmPage'
// import RegistrationEditPage from './RegistrationEditPage'
// import PaymentPage from './PaymentPage'
import DashboardPage from './DashboardPage'
// import LinepayConfirmHook from './LinepayConfirmHook'
import ProfilePage from './ProfilePage'
import EditProfilePage from './EditProfilePage'
import ResetPassword from './ResetPassword'
import ResetPasswordInput from './ResetPasswordInput'
import i18nStore from './stores/i18n'
import withUser from '~/App/hocs/withUser'
import withTracker from '~/App/hocs/withTracker'
import { AppWrapper } from '~/styles'
import './index.css'

const clientTitle = process.env.REACT_APP_CLIENT_TITLE

const stores = {
  i18n: i18nStore
}

@withUser()
class PrivateRoute extends Component {
  componentWillReceiveProps (nextProps) {
    const { currentUser, currentUserLoading, onAuth, location } = nextProps
    if (!currentUser && !currentUserLoading) {
      message.info('Please login or register', 20)
      onAuth({ redirectTo: `${process.env.REACT_APP_BASE_URI}${location.pathname}${location.search}` })
    }
  }
  render () {
    const { component: Component,
      render,
      currentUser,
      currentUserLoading,
      onAuth,
      ...rest
    } = this.props
    return <Route
      {...rest}
      render={props => {
        if (currentUser) {
          return Component ? <Component {...props} /> : render(props)
        }
        if (currentUserLoading) return <div>Loading...</div>

        return (
          <Redirect
            to={{
              pathname: '/',
              state: { from: props.location }
            }}
          />
        )
      }}
    />
  }
}

@withRouter
@withUser()
@observer
class App extends Component {
  state = {
    showAuthModal: false,
    redirectTo: null
  }

  showAuthModal = ({ redirectTo }) => {
    // e.preventDefault()
    this.setState({
      showAuthModal: true,
      redirectTo
    })
  }

  hideAuthModal = () => {
    this.setState({
      showAuthModal: false,
      redirectTo: null
    })
  }

  handleAuth = ({ redirectTo }) => {
    this.showAuthModal({ redirectTo })
  }

  render () {
    return <AppWrapper>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>{clientTitle}</title>
      </Helmet>
      <CookiesProvider>
        <Provider {...stores}>
          <ConnectedLocaleProvider>
            <ConnectedIntlProvider>
              <Switch>
                <Route exact path="/reg/:regId/payatall" />
                <Route render={() => <Layout>
                  <Layout.Header>
                    <Header onAuthClick={this.showAuthModal} />
                  </Layout.Header>
                  <Layout.Content >
                    <Switch>
                      <Route exact path="/" component={withTracker(EventListPage)} />
                      <Route exact path="/events" component={withTracker(EventListPage)} />
                      <Route exact path="/events/:eventSlug" component={withTracker(EventPage)} />
                      <Route exact path="/password/reset" component={withTracker(ResetPasswordInput)} />
                      <Route exact path="/reset/:resetToken" component={withTracker(ResetPassword)} />
                      <PrivateRoute exact path="/profile" component={withTracker(ProfilePage)} onAuth={this.handleAuth}/>
                      <PrivateRoute exact path="/profile/edit" component={withTracker(EditProfilePage)} onAuth={this.handleAuth}/>
                      <PrivateRoute exact path="/events/:eventSlug/register" component={withTracker(EventRegistration)} onAuth={this.handleAuth}/>
                      <PrivateRoute exact path="/events/:eventSlug/private" component={withTracker(EventRegistration)} onAuth={this.handleAuth}/>
                      <PrivateRoute path="/reg/:id" component={withTracker(EventRegistration)} onAuth={this.handleAuth}/>
                            } />
                      {/* <PrivateRoute
                        path="/paymentcancel"
                        component={withTracker(PaymentCancelHook)}
                        <PrivateRoute path="/reg/:id/pay" component={withTracker(PaymentPage)} onAuth={this.handleAuth}/>
                      /> */}
                      <PrivateRoute path="/dashboard" component={withTracker(DashboardPage)} onAuth={this.handleAuth}/>
                    </Switch>
                  </Layout.Content>
                  <Layout.Footer>
                    <Footer />
                  </Layout.Footer>
                  <AuthModal visible={this.state.showAuthModal} onClose={this.hideAuthModal} redirectTo={this.state.redirectTo} />
                </Layout>}
                />
              </Switch>
            </ConnectedIntlProvider>
          </ConnectedLocaleProvider>
        </Provider>
      </CookiesProvider>
    </AppWrapper>
  }
}

// TODO: Refactor auth logic decouple state and actions
export default App



// WEBPACK FOOTER //
// ./src/App/App.js